import { render, staticRenderFns } from "./EntityCandidate.vue?vue&type=template&id=e3a37872&lang=pug&"
import script from "./EntityCandidate.vue?vue&type=script&lang=ts&"
export * from "./EntityCandidate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports